import { message } from 'antd';

export const copyToClipBoard = (value) => {
  navigator.clipboard.writeText(value);
  message.success("Copiado para a área de transferência!");
}